var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`cv-radio-group ${_vm.carbonPrefix}--form-item`},[_c('div',{class:[`${_vm.carbonPrefix}--radio-button-group`, { [`${_vm.carbonPrefix}--radio-button-group--vertical`]: _vm.vertical }]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }